import { customfin, greensky, fortiva, ygrene, marlin, stressfree, wellsfargo } from 'Helpers/lenders.js'

export default {
  data() {
    return {
      greensky,
      fortiva,
      ygrene,
      customfin,
      marlin,
      //We label the fpl data stressfree because data rendered on ApplicationsList.vue and 
      //LeadsList seek out 'stressfree,' rather than 'fpl.' We label 'stressfree' id of the fpl object we define in
      //helpers.lenders.js because the lender code we receive from 'getLoanApplicationHistory' (which loads our
      //applications in ApplicationHistory.vue), is 'stressfree.
      stressfree,
      wellsfargo,
      lenders: [{
        ...greensky,
        name: 'greensky',
        planExpanderComponent: 'GreenskyPlanExpander',
        selected: false,
        // probably gonna make lender specific agreement components
        agreement: `<p>
          I certify that the information submitted is true, accurate,
          and complete. By submitting this application, I certify that
          I have read and agree to the
          <a class="wf-link" target="blank"
            href="https://www.greensky.com/docs/core/agreements/program_agreement.pdf"
          >Disclosures</a> and
          <a class="wf-link" target="blank"
            href="https://www.greensky.com/docs/core/agreements/program_agreement.pdf"
          >Program Agreement.</a>
        </p><p>
          Sole Proprietorships and Partnerships: The Greensky Program may
          check and verify credit history and secure credit reports of the
          Applicant and any named principals, owners, or partners. The
          named principals, owners, and partners instruct any third party
          including but not limited to any consumer reporting agency,
          partner, and vendor to provide such report.
        </p>`,
        agreementStateProp: 'enrollment.appliedGreensky',
      }, {
        ...fortiva,
        name: 'fortiva',
        planExpanderComponent: 'FortivaPlanExpander',
        selected: false,
        agreement: `<p>
          I have read and agree to the Fortiva
          <a class="wf-link" target="blank"
            href="https://s3.amazonaws.com/allhvac/Watsco+-+9.9+with+6.5+rev.0218+_+Blank.pdf"
          >Terms and Conditions</a>.
        </p>`,
        agreementStateProp: 'enrollment.appliedFortiva',
      }, {
        ...ygrene,
        name: 'ygrene',
        planExpanderComponent: 'YgrenePlanExpander',
        selected: false,
        agreement: `<p>
          All owners listed understand that Ygrene may make reference
          inquiries and order credit reports and/or independent background
          investigations on the company and its principals to determine
          eligibility in Ygrene Specialy Programs.
        </p>`,
        agreementStateProp: 'enrollment.appliedYgrene',
      }],
    }
  },
  methods: {
    companyLogo (lender) {
      return (lender !== undefined)
        ? this[lender].logoSvg
        : null
    },
  },
}
